// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"806":"f5d2eea9c509a60d","888":"8ae9eac2bd787df2"}[chunkId] + ".css";
};